import script from "./SpeV2Dismiss.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2Dismiss.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2Dismiss.vue?vue&type=style&index=0&id=faafef2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faafef2c"]])

export default __exports__